<template>
  <div class="whatsapp-button-container">
    <a
      :href="whatsappUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="whatsapp-button"
    >
      <div class="whatsapp-icon-container">
        <i class="fab fa-whatsapp whatsapp-icon"></i>
      </div>
      <span class="whatsapp-text">{{ $t('footer.needs_help') }}</span>
    </a>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const phoneNumber = ref("00966537767705"); // Replace with your WhatsApp number

const whatsappUrl = ref(`https://wa.me/${phoneNumber.value}`);
</script>

<style scoped>
.whatsapp-button-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.whatsapp-button {
  display: flex;
  align-items: center;
  background-color: #25D366; /* WhatsApp green */
  color: white;
  text-decoration: none;
  padding: 10px 15px;
  border-radius: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.whatsapp-button:hover {
  background-color: #128C7E;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.whatsapp-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.whatsapp-icon {
  font-size: 24px;
}

.whatsapp-text {
  font-weight: 600;
  font-size: 16px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .whatsapp-button-container {
    bottom: 15px;
    right: 15px;
  }

  .whatsapp-button {
    padding: 8px 12px;
  }

  .whatsapp-icon {
    font-size: 20px;
  }

  .whatsapp-text {
    font-size: 14px;
  }
}

/* RTL Support */
[dir="rtl"] .whatsapp-icon-container {
  margin-right: 0;
  margin-left: 10px;
}
</style>